import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { AuthenticationProvider } from '@heidelbergmaterials/fcl-authclient'
import { AllCommunityModule } from 'ag-grid-community'
import { AgGridProvider } from 'ag-grid-react'
import { faim2Theme } from './theme/muiTheme'
import { ENV } from './settings'
import './index.css'
import { App } from './App'

const agGridModules = [AllCommunityModule];

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={faim2Theme}>
    <CssBaseline />
    <AgGridProvider modules={agGridModules}>
      <AuthenticationProvider
        identityProvider={ENV.identity_provider}
        clientId={ENV.client_id}
        identityServerUrl={ENV.identity_server_url}
        authRedirectUri={ENV.auth_redirect_uri}
        oauthScopes={ENV.oauth_scopes}
        autoRedirect={ENV.auto_redirect}
      >
        <App />
      </AuthenticationProvider>
    </AgGridProvider>
    </ThemeProvider>
  </StrictMode>,
)
